import { i18n } from "~Shared/locales/i18n"
import { NotificationService } from "~Shared/services"
import { NotificationTypeEnum } from "~Shared/services/notification.service"

export const openWindowInNewTab = ({ url, target, features }: { url: string; target?: "_blank" | "_self"; features?: string }) => {
    const newWindow = window.open(url, target || "_blank", features)

    // Check if pop-up was blocked
    // window.open() returns null when blocked
    if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
        NotificationService.send(NotificationTypeEnum.WARNING, i18n.t("notification:window.popup_blocked.title"), i18n.t("notification:window.popup_blocked.message"))
        return false
    }

    return true
}
